//过滤我的资料
//1.将对象中的key转成一个数组
//2.过滤这个数组
//3.判断数组是否包含这个key
//4.遍历数组，并赋值
export function filteringInformation(info, ref, aaaa) {
    //判断用户信息是否存在json  存在就让form表单中的json等于原来的样子
    if (info.json == null || Object.keys(info.json).length == 0) aaaa = ref.json
    Object.keys(info).filter((key) => Object.keys(ref).includes(key)).forEach((key) => {
            ref[key] = info[key]
        })
        //判断用户信息是否存在json 存在就让form表单中的json等于用于信息的json
    if (info.json == null || Object.keys(info.json).length == 0) ref.json = aaaa
    return ref
}